import {
  CaracteristicasState,
  MetadataState,
  caracteristicasInitialState,
  metadataInitialState,
  caracteristicasAction,
} from 'store/modules/cri/caracteristicas';
import { CriteriosRemuneracaoAction, criteriosRemuneracaoInitialState } from 'store/modules/cri/criteriosRemuneracao';
import { EventosAction, eventosInitialState } from 'store/modules/cri/eventos';
import { UploadDocumentosAction, uploadDocumentosInitialState } from 'store/modules/cri/uploadDocumentos';
import { EmissorAction, State as EmissorState, initialState as emissorInitialState } from 'store/modules/cri/emissor';
import { CriteriosRemuneracao, Amortizacao, UploadDocumentos, TipoRegistroInstrumentoFinanceiro, EventosFinanceiros as EventosState } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Attachment } from 'components/uploadDocs';
import { AditamentoAction } from './aditamento';

interface State {
  caracteristicas: CaracteristicasState;
  metadata: MetadataState;
  criteriosRemuneracao: CriteriosRemuneracao;
  emissor: EmissorState;
  eventos: EventosState;
  uploadDocumentos: UploadDocumentos;
  highlightErrors: boolean;
  typeOfRegister: TipoRegistroInstrumentoFinanceiro;
  uploadDocumentoAditamento: Attachment[];
  dataAditamento: string | undefined;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('cri/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('cri/HIGHLIGHT_ERRORS', payload);
};

export function criReducer(
  state: State = {
    caracteristicas: caracteristicasInitialState,
    metadata: metadataInitialState,
    criteriosRemuneracao: criteriosRemuneracaoInitialState,
    emissor: emissorInitialState,
    eventos: eventosInitialState,
    uploadDocumentos: uploadDocumentosInitialState,
    highlightErrors: false,
    typeOfRegister: TipoRegistroInstrumentoFinanceiro.Cadastro,
    uploadDocumentoAditamento: [],
    dataAditamento: undefined,
  },
  action:
    | caracteristicasAction
    | CriteriosRemuneracaoAction
    | EmissorAction
    | EventosAction
    | UploadDocumentosAction
    | ReturnType<typeof highlightErrors>
    | ReturnType<typeof typeOfRegister>
    | AditamentoAction
): State {
  switch (action.type) {
    //Características
    case 'cri/metadata/UPDATEFIELD':
      return { ...state, metadata: { ...state.metadata, [action.payload.name]: action.payload.value } };
    case 'cri/caracteristicas/UPDATEFIELD':
      return { ...state, caracteristicas: { ...state.caracteristicas, [action.payload.name]: action.payload.value } };
    case 'cri/caracteristicas/RESET':
      return { ...state, caracteristicas: { ...caracteristicasInitialState } };
    case 'cri/caracteristicas/UPDATE':
      return { ...state, caracteristicas: action.payload };
    //Critério de Remuneração
    case 'cri/criteriosRemuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: { ...state.criteriosRemuneracao, [action.payload.name]: action.payload.value },
      };
    case 'cri/criteriosRemuneracao/remuneracao/UPDATE':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: action.payload,
        },
      };
    case 'cri/criteriosRemuneracao/remuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: { ...state.criteriosRemuneracao.remuneracao, [action.payload.name]: action.payload.value },
        },
      };
    case 'cri/criteriosRemuneracao/RESET':
      return { ...state, criteriosRemuneracao: criteriosRemuneracaoInitialState };
    case 'cri/criteriosRemuneracao/UPDATE':
      return { ...state, criteriosRemuneracao: action.payload };
    //Custo de Emissão
    case 'cri/criteriosRemuneracao/custoEmissao/UPDATEFIELD':
      return { 
        ...state, 
        criteriosRemuneracao: { 
          ...state.criteriosRemuneracao, 
          custoEmissao: {
            ...state.criteriosRemuneracao.custoEmissao, [action.payload.name]: action.payload.value },
        }
      };
    //Emissor
    case 'cri/emissor/UPDATE_ID':
      return { ...state, emissor: { ...state.emissor, id: action.payload } };
    case 'cri/emissor/UPDATE_CODIGO':
      return { ...state, emissor: { ...state.emissor, codigoExterno: action.payload } };
    case 'cri/emissor/RESET':
      return { ...state, emissor: { ...emissorInitialState } };
    //Eventos Financeiros
    case 'cri/eventos/UPDATE':
      return { ...state, eventos: action.payload };
    case 'cri/eventos/UPDATEFIELD':
      return { ...state, eventos: { ...state.eventos, [action.payload.name]: action.payload.value } };
    case 'cri/eventos/RESET':
      return { ...state, eventos: eventosInitialState };
    case 'cri/eventos/datasPagamentoJuros/UPDATE':
      return {
        ...state,
        eventos: { ...state.eventos, datasPagamentoJuros: action.payload.map((dateViewModel) => dateViewModel.date) },
      };
    case 'cri/eventos/datasIncorporacaoJuros/UPDATE':
      return {
        ...state,
        eventos: {
          ...state.eventos,
          datasIncorporacaoJuros: action.payload.map((dateViewModel) => dateViewModel.date),
        },
      };
    case 'cri/eventos/amortizacoes/UPDATE':
      const amortizacoes: Amortizacao[] = action.payload.map((amortizacao) => ({
        percentualAmortizacao: amortizacao.percentualAmortizacao,
        dataAmortizacao: amortizacao.dataAmortizacao,
      }));
      return {
        ...state,
        eventos: { ...state.eventos, amortizacoes },
      };
    //Documentos
    case 'cri/uploadDocumentos/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documents: action.payload },
      };
    case 'cri/uploadDocumentos/documentsToDelete/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documentsToDelete: action.payload },
      };
    case 'cri/uploadDocumentos/RESET':
      return { ...state, uploadDocumentos: uploadDocumentosInitialState };
    //Erros
    case 'cri/HIGHLIGHT_ERRORS':
      return { ...state, highlightErrors: action.payload };
    default:
      return state;
    //Type of Register
    case 'cri/TYPE_OF_REGISTER':
      return { ...state, typeOfRegister: action.payload };
    //Aditamento
    case 'cri/UPLOAD_DOCUMENTO_ADITAMENTO':
      return { ...state, uploadDocumentoAditamento: action.payload };
    case 'cri/UPLOAD_DOCUMENTO_ADITAMENTO/RESET':
      return { ...state, uploadDocumentoAditamento: [] };
    case 'cri/DATA_ADITAMENTO':
      return { ...state, dataAditamento: action.payload };
    case 'cri/DATA_ADITAMENTO/RESET':
      return { ...state, dataAditamento: undefined };
  }
}

export default criReducer;
